export default __webpack_public_path__ + "alberta-fab-patient-active.11a232f001eef7d1a27f.svg";